import React, { useCallback, useMemo } from 'react'
import { Tonality } from '@dsny/dsny-component-library'
import {
  DownloadSectionWrapper,
  StyledButton
} from './DownloadSectionNew.styles'
import { useTranslation } from 'react-i18next'
import { hasPromoEmailContent } from '../../utils'
import useReleaseInformationResponsiveBreakpointsV2 from '../../hooks/useReleaseInformationResponsiveBreakpointsV2'

const DownloadSectionNew = ({ release, handleDownload, isMobile }) => {
  const { t } = useTranslation()
  const responsiveBreakpointsV2 = useReleaseInformationResponsiveBreakpointsV2()
  const downloadSource = 'release_information_download_section'
  const hasPromoDetails = useMemo(
    () => hasPromoEmailContent(release?.promoinfo),
    [release?.promoinfo]
  )

  const scrollToPromoDetails = useCallback(() => {
    const promoSection = document.getElementById('promo-section')
    if (promoSection) {
      promoSection.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      })
    }
  }, [])

  const tooltipContainerStyles = {
    fontSize: 12,
    fontFamily: 'Nunito Sans',
    padding: '4px 8px',
    margin: '-6px 0 0',
    borderRadius: 5,
    boxShadow: '0px 0px 8px rgba(0, 0, 0, 0.25)',
    height: 'auto'
  }

  const tooltipWrapperStyles = {
    width: isMobile ? '100%' : 'auto',
    display: isMobile ? 'block' : 'inline-flex'
  }

  const renderDownloadButton = ({ format, label, mode, buttonStyle }) => (
    <StyledButton
      $responsiveBreakpointsV2={responsiveBreakpointsV2}
      variant="primary"
      setting="player"
      mode={mode}
      onClick={() => handleDownload(release, format, downloadSource)}
      disabled={!release?.candownload}
      style={buttonStyle}
    >
      {label}
    </StyledButton>
  )

  return (
    <DownloadSectionWrapper $responsiveBreakpointsV2={responsiveBreakpointsV2}>
      {release?.candownload ? (
        renderDownloadButton({
          format: 'wav',
          label: t('release-info.download-wav')
        })
      ) : (
        <Tonality.Tooltip
          hasArrow={false}
          placement="top"
          content={t('release-info.stream-only-feedback')}
          mode="dark"
          containerStyles={tooltipContainerStyles}
          wrapperStyles={tooltipWrapperStyles}
        >
          <div style={tooltipWrapperStyles}>
            {renderDownloadButton({
              format: 'wav',
              label: t('release-info.download-wav')
            })}
          </div>
        </Tonality.Tooltip>
      )}
      {release?.candownload ? (
        renderDownloadButton({
          format: 'mp3',
          label: t('release-info.download-mp3'),
          mode: 'dark'
        })
      ) : (
        <Tonality.Tooltip
          hasArrow={false}
          placement="top"
          content={t('release-info.stream-only-feedback')}
          mode="dark"
          containerStyles={tooltipContainerStyles}
          wrapperStyles={tooltipWrapperStyles}
        >
          <div style={tooltipWrapperStyles}>
            {renderDownloadButton({
              format: 'mp3',
              label: t('release-info.download-mp3'),
              mode: 'dark',
              buttonStyle: {
                background: 'unset'
              }
            })}
          </div>
        </Tonality.Tooltip>
      )}

      {hasPromoDetails && (
        <StyledButton
          $responsiveBreakpointsV2={responsiveBreakpointsV2}
          variant="secondary"
          setting="player"
          mode="dark"
          onClick={scrollToPromoDetails}
        >
          {t('release-info.promo-details')}
        </StyledButton>
      )}
    </DownloadSectionWrapper>
  )
}

export default DownloadSectionNew
